import React from "react";
import {
  Col,
  Row,
  message,
  Button,
  Space,
  Tooltip,
  Modal,
  Image,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import { CloseOutlined } from "@ant-design/icons";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import VehicleDistanceStore from "../store/VehicleDistanceStore";
import withRouter from "../withRouter";
import CompanyStore from "../store/CompanyStore";
import VehicleDistanceAdd from "./VehicleDistanceAdd";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";

class VehicleDistanceList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.companyStore = new CompanyStore(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.vehicleDistanceStore = new VehicleDistanceStore();
    this.onDelete = this.onDelete.bind(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      companyId: "",
      loadData: 0,
      openConfirm: false,
      confirmLoading: false,
      company_value_label: "",
      listUpdated: 0,
      vehicleDistanceId: "",
      openVehicleDistanceForm: false,
      listDataUpdate: false,

      openDeleteModal: false,
      deleteData: {},
    };

    this.columns = [
      {
        // title: "  Account",
        title: context.translate("_FLEET_DASHBORD_NEWPOI_CUSTOMER_"),
        dataIndex: "companyName",
        width: 25,
        ellipsis: {
          showTitle: true,
        },
        render: (value, record) => {
          return (
            <Tooltip placement="topLeft" title={value}>
              <Link
                style={{ color: "#2563EB", textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.props.canUpdate("vehicledistancelist") &&
                    this.onEdit(record);
                }}
              >
                {value}
              </Link>
            </Tooltip>
          );
        },
      },
      {
        // title: " Vehicle No ",
        title: context.translate("_VEHICLE_NO_"),
        dataIndex: "vehicleNo",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: " Start Odometer",
        title: context.translate("_START_ODOMETER_"),
        dataIndex: "startOdometer",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: " Stop Odometer",
        title: context.translate("_STOP_ODOMETER_"),
        dataIndex: "endOdometer",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: " Distance Travelled",
        title: context.translate("_FLEET_RULESELECTORDETAIL_RULE13_TITLE_"),
        dataIndex: "distanceTravel",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "   Date ",
        title: context.translate("_FLEET_REPORTS_DATE_"),
        dataIndex: "entryDate",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "Action",
        key: "Action",
        // fixed: 'right',
        width: 10,
        align: "center",
        ellipsis: {
          showTitle: true,
        },
        render: (_, record) => {
          return (
            <>
              <Space>
                {/* <Link
                  onClick={(e) => {
                    e.preventDefault();
                    this.onEdit(record);
                  }}
                >
                  <Tooltip
                    // title="Edit Details"
                    title={context.translate("_EDIT_DETAILS_")}
                    placement="bottom"
                    color={config.tooltipColorEdit}
                  >
                    <EditFilled />
                  </Tooltip>
                </Link> */}
                {/* <DeleteConfirm
                  onConfirm={(e) => {
                    e.preventDefault();
                    this.onDelete(record);
                  }}
                >
                  <Link>
                    <Tooltip
                      // title="Delete"
                      title={context.translate(
                        "_FLEET_DASHBORD_RULETRIGGER_DELETE_"
                      )}
                      placement="bottom"
                      color={config.tooltipColorDelete}
                    >
                      <DeleteFilled style={{ color: config.deleteColor }} />
                    </Tooltip>
                  </Link>
                </DeleteConfirm> */}

                <Tooltip
                  title={this.context.translate(
                    "_FLEET_COMPANY_COMPANYLIST_EDIT_"
                  )}
                >
                  {this.props.canUpdate("vehicledistancelist") && (
                    <Image
                      style={{
                        height: "19px",
                        width: "15px",
                        borderRadius: "0px",
                        cursor: "pointer",
                      }}
                      src={editIcon}
                      onClick={async (e) => {
                        e.preventDefault();
                        await this.onEdit(record);
                      }}
                    ></Image>
                  )}
                </Tooltip>
                <Tooltip
                  title={this.context.translate(
                    "_FLEET_COMPANY_COMPANYLIST_DELETE_"
                  )}
                >
                  {this.props.canDelete("vehicledistancelist") && (
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer", width: "15px" }}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    ></Image>
                  )}
                </Tooltip>
              </Space>
            </>
          );
        },
      },
    ];
  }
  onEdit = async (record) => {
    console.log(record);
    console.log("manualDistanceId", record.manualDistanceId);
    await this.context.viewStateStore.setVehicleDistanceStates({
      companyId: record.companyId,
    });
    await this.setState({ vehicleDistanceId: record.manualDistanceId });
    await this.setState({ openVehicleDistanceForm: true });
    // await this.props.navigate("/vehicledistanceadd/" + record.manualDistanceId);
  };

  async onDelete(record) {
    const response = await this.vehicleDistanceStore.deleteRecord({
      manualDistanceId: record.manualDistanceId,
    });
    //  console.log(response.data.success)
    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const beforeEditCompanyId =
        this.context.viewStateStore.vehicleDistanceObject.companyId;
      if (beforeEditCompanyId !== "") {
        await this.vehicleDistanceStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: beforeEditCompanyId,
        });
        const singleData = await this.companyStore.getCompanyDataById(
          this.context.viewStateStore.vehicleDistanceObject.companyId
        );
        await this.setState({ company_value_label: singleData });
        this.setState({ listDataUpdate: false });
      }
    }
  }
  async componentDidMount() {
    if (Number(this.props.getUserData().isadmin) !== -1 && Number(this.props.getUserData().isadmin) !== 3) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }
    // await this.vehicleDistanceStore.loadData({ offset: 0, limit: 50 });

    await this.setState({ listUpdated: 1 }); //need to reload data

    this.setState({ pageSize: 50 });
  }
  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({
      companyId: comp.value,
      currentPage: 1,
      pageSize: 50,
    });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    await this.setState({ company_value_label: singleData });
    await this.handleSearch();
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.vehicleDistanceStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      // searchField: this.state.searchField,
      companyId: this.state.companyId,
      currentPage: this.state.currentPage,
    });
    await this.setState({ loadData: 1 });
  }

  responseMsg = async (resp) => {
    console.log(resp);
    if (resp.data.success == "S") {
      message.success(resp.data.message);
      // this.props.navigate("/vehicledistancelist");
      await this.setState({ listDataUpdate: true });
      await this.setState({ openVehicleDistanceForm: false });
    } else if (resp.data.success == "F0") {
      resp.data.errors.map((value) => {
        message.error(
          "You have already entered readings for selected vehicle for this date"
        );
      });
    } else {
      message.error(resp.data.message);
    }
  };

  refreshList = async () => {
    this.setState({ loading: true });
    if (this.state.companyId) {
      await this.vehicleDistanceStore.loadData({
        companyId: this.state.companyId,
        offset: 0,
        limit: 50,
      });
    }
    this.setState({ loading: false, currentPage: 1 });
  };
  closeModal = () => {
    this.setState({
      openVehicleDistanceForm: false,
      vehicleDistanceId: "",
    });
  };
  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  //  allowClear={true}
                  value={
                    this.state.company_value_label
                      ? this.state.company_value_label
                      : null
                  }
                  onChange={(value) => this.handleChange(value)}
                  style={{ width: 200 }}
                />
              </Space>
            </Col>
            <Col
              span={8}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Tooltip
                title={this.context.translate("_REFRESH_")}
                placement="bottom"
              >
                <Image
                  style={{
                    height: 18,
                    alignItems: "center",
                    cursor: "pointer",
                    marginInlineEnd: "20px",
                  }}
                  src={refreshIcon}
                  onClick={() => this.refreshList()}
                ></Image>
              </Tooltip>
              {this.props.canCreate("vehicledistancelist") && (
                <Button
                  className="addButtonClass"
                  onClick={() => {
                    this.setState({
                      openVehicleDistanceForm: true,
                      vehicleDistanceId: "",
                    });
                  }}
                >
                  <Image
                    style={{ marginInlineEnd: "5px", width: 13 }}
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  ></Image>
                  {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                </Button>
              )}
            </Col>
          </Row>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.vehicleDistanceStore?.total}
            columns={this.columns}
            dataSource={this.vehicleDistanceStore?.vehicleDistanceVehicles}
            loading={this.vehicleDistanceStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openVehicleDistanceForm && (
          // <Modal
          //   bodyStyle={{ height: "645px" }}
          //   className="formShowModal" //  {/* css class */}
          //   // title="Assign Bus To Student"
          //   title={this.context.translate(
          //     "_VEHICLE_DISTANCE_TRAVELLED_DETAILS_"
          //   )}
          //   centered
          //   visible={this.state.openVehicleDistanceForm}
          //   footer={null}
          //   onCancel={() => {
          //     this.setState({
          //       openVehicleDistanceForm: false,
          //       vehicleDistanceId: "",
          //     });
          //   }}
          //   width={665}
          // >
          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openVehicleDistanceForm}
            placement={
              this.context.locale.language === "arabic" ? "left" : "right"
            }
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_VEHICLE_DISTANCE_TRAVELLED_DETAILS_")}
                <p className="formDescription">
                  {this.context.translate("_VEHICLE_DISTANCE_ADD_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openVehicleDistanceForm: false })}
            onCancel={() =>
              this.setState({
                openVehicleDistanceForm: false,
                vehicleDistanceId: "",
              })
            }
          >
            <div style={{ height: "100%" }}>
              <VehicleDistanceAdd
                vehicleDistanceId={this.state.vehicleDistanceId}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
VehicleDistanceList.contextType = StoreContext;
export default observer(withRouter(VehicleDistanceList));
